export default "چطور\nچرا\nچقدر"